import { render, staticRenderFns } from "./BaseComposite.vue?vue&type=template&id=5a3ab4d4"
import script from "./BaseComposite.vue?vue&type=script&lang=ts"
export * from "./BaseComposite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports